import { Engine1Proxy, SagasProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';

let procesoId = undefined;
let ConfiguracionProcesosManager = function () {
    // const agregarProceso = (x => x.Checked && x.Id > 0);
    const editarProceso = (x => (x.Id > 0 && x.Cambio));

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarProceso(data, sagasCallback, viewCallback) {
        ejecutarSagasProceso(data, sagasCallback, viewCallback)
    }


    /**
   * 
   * @param {any} data
   * @param {any} sagasCallback
   * @param {any} viewCallback
   */
    function ejecutarSagasProceso(data, sagasCallback, viewCallback) {


        let localValues = agregarProceso(data);
        ejecutarSagas(localValues, 'CONFIGURACION_PROCESO', sagasCallback, viewCallback);
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {

        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "PROCESOS");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "PROCESOS");
    }

    function agregarProceso(data) {
        const { proceso, calendario } = data;
      
        let localValues = {
            "PROCESO_CONTAINER": {
                "Proceso": {
                    "Id": proceso.ProcesoId,
                    "Nombre": proceso.NombreProceso,
                    "Descripcion": proceso.DescripcionProceso,
                    "TipoProceso": proceso.TipoProceso,
                    "EstaActivo": proceso.EstaActivo,
                    "OrdenEjecucion": proceso.OrdenEjecucion,
                    "ProcesamientoParcial": proceso.ProcesamientoParcial,
                    "LimiteRechazos": proceso.LimiteRechazos,
                    "PermiteVacio": proceso.PermiteVacio,
                    "CantidadDiasHabilesReproceso": proceso.CantidadDiasHabilesReproceso,
                    "ArchivoAsociado": proceso.ArchivoAsociado,
                    "FormatoFechaArchivoId": proceso.FormatoFechaArchivoId,
                    "FormatoHoraArchivoId": proceso.FormatoHoraArchivoId,
                    "FormatoNombreArchivoId": proceso.FormatoNombreArchivoId,
                    "TipoSeparacionArchivo": proceso.TipoSeparacionArchivo
                },
                "Calendario": {
                    "Id": data.calendarioId,
                    "ProcesoId": proceso.ProcesoId,
                    "Activo": calendario.Activo,
                    "Periodicidad": proceso.Periodicidad,
                    "DiaHabil": calendario.DiaHabil,
                    "DiaInicio": calendario.DiaInicio,
                    "DiaFin": calendario.DiaFin,
                    "DiaMes": calendario.DiaMes,
                    "CarteraId": calendario.CarteraId,
                    "DiaDesdeCierre": calendario.DiaDesdeCierre,
                    "DiaSemanaLunes": calendario.DiaSemanaLunes,
                    "DiaSemanaMartes": calendario.DiaSemanaMartes,
                    "DiaSemanaMiercoles": calendario.DiaSemanaMiercoles,
                    "DiaSemanaJueves": calendario.DiaSemanaJueves,
                    "DiaSemanaViernes": calendario.DiaSemanaViernes,
                    "DiaSemanaSabado": calendario.DiaSemanaSabado,
                    "DiaSemanaDomingo": calendario.DiaSemanaDomingo
                }
            }
        }

        return localValues;
    }




    return {
        GuardarProceso: function (data, sagasCallback, viewCallback) {
            return _guardarProceso(data, sagasCallback, viewCallback);
        },

    }
};
let configuracionProcesosManager = new ConfiguracionProcesosManager();
export default configuracionProcesosManager;